export enum PeriodType {
  RollingDays = 1,
  DateRange = 2,
  Indefinitely = 3,
}
